module.exports = __webpack_public_path__ + "img/character-unselected.87ccc2be.svg";